<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_xi"></a><a id="ch007_Abb"></a><strong>Abbreviations List</strong></h2>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="noindent">ASHA</p></td>
<td valign="top"><p class="texthangingindent">American Social Hygiene Association</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">ASHA Papers</p></td>
<td valign="top"><p class="texthangingindent">American Social Hygiene Association Papers, Social Welfare History Archives Center, University of Minnesota, Minneapolis</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">BSH Papers</p></td>
<td valign="top"><p class="texthangingindent">Bureau of Social Hygiene Papers, Rockefeller Archives Center, North Tarrytown, New York</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">CCC</p></td>
<td valign="top"><p class="texthangingindent">Civilian Conservation Corps</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">CTCA</p></td>
<td valign="top"><p class="texthangingindent">Commission on Training Camp Activities</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">FSA</p></td>
<td valign="top"><p class="texthangingindent">Federal Security Agency</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">NA</p></td>
<td valign="top"><p class="texthangingindent">National Archives, Washington, DC</p></td>
</tr>
<tr>
<td valign="top"><p class="texthangingindent">RG 215</p></td>
<td valign="top"><p class="texthangingindent">Record Group 215, Records of the Office of Community War Services, Social Protection Division</p></td>
</tr>
<tr>
<td valign="top"><p class="texthangingindent">RG 18</p></td>
<td valign="top"><p class="texthangingindent">Record Group 18, Records of the Army Air Force</p></td>
</tr>
<tr>
<td valign="top"><p class="texthangingindent">RG 52</p></td>
<td valign="top"><p class="texthangingindent">Record Group 52, Records of the Navy Bureau of Medicine and Surgery</p></td>
</tr>
<tr>
<td valign="top"><p class="texthangingindent">RG 287</p></td>
<td valign="top"><p class="texthangingindent">Record Group 287, Uniform Crime Reports for the United States and Its Possessions, Federal Bureau of Investigation, U.S. Department of Justice</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">NAPCSP</p></td>
<td valign="top"><p class="texthangingindent">National Advisory Police Committee on Social Protection</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">NSA</p></td>
<td valign="top"><p class="texthangingindent">National Sheriffs Association</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">NWACSP</p></td>
<td valign="top"><p class="texthangingindent">National Women’s Advisory Committee on Social Protection</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">OCWS</p></td>
<td valign="top"><p class="texthangingindent">Office of Community War Services</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">ODHWS</p></td>
<td valign="top"><p class="texthangingindent">Office of Defense, Health and Welfare Services</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">OWI</p></td>
<td valign="top"><p class="texthangingindent">Office of War Information</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">SPD</p></td>
<td valign="top"><p class="texthangingindent">Social Protection Division</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">USO</p></td>
<td valign="top"><p class="texthangingindent">United Service Organization</p></td>
</tr>
<tr>
<td valign="top"><p class="noindent">USPHS</p></td>
<td valign="top"><p class="texthangingindent">U.S. Public Health Service <a id="page_xii"></a></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007_Abb.vue?3484f658